<template>
  <div class="container-fluid">
    <div class="row mw-node-container justify-content-center">
      <!-- URGENT NOTIFICATION -->
      <div class="col-0 col-lg-2 mw-node-side-container">
        <PreviousItemsSideCard v-if="previousItems.length" class="mb-4" />
        <UrgentNotificationSide />
      </div>
      <!-- MAIN CARD -->
      <MaydayNodeMain
        class="col-12 col-lg-8"
        :companyColor="companyColor"
        @open-feedback-modal="openFeedbackModal"
      />
      <div class="col-0 col-lg-2 mw-node-side-container"></div>
    </div>
  </div>
</template>

<script>
import PreviousItemsSideCard from './Node/PreviousItemsSideCard';
import MaydayNodeMain from './Node/MaydayNodeMain/MaydayNodeMain';
import UrgentNotificationSide from './Node/UrgentNotificationSide';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'MaydayWebNode',
  components: {
    UrgentNotificationSide,
    MaydayNodeMain,
    PreviousItemsSideCard,
  },
  props: {
    companyColor: String,
  },
  computed: {
    ...mapGetters('webKnowledgeModule', [
      'favorites',
      'previousItems',
      'searchQuery',
    ]),
  },
  watch: {
    searchQuery() {
      if (this.previousItems.length) {
        this.updatePreviousItems([]);
      }
    },
  },
  methods: {
    ...mapActions('webKnowledgeModule', ['updatePreviousItems']),
    openFeedbackModal(content) {
      this.$emit('open-feedback-modal', content);
    },
  },
};
</script>

<style lang="scss" scoped>
.mw-node-container {
  margin-top: -74px;
}

.mw-node-side-container {
  margin-top: 102px;
}

@media (max-width: 991px) {
  .mw-node-container {
    margin-top: -155px;
  }
}
</style>
